var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMottaker = function SvgMottaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 7.707 6.9 3.035V20l-6.138-2.49A1.22 1.22 0 0 1 4 16.38zm16-.355-.117 8.413c-.007.494-.31.935-.77 1.118l-7.802 3.106v-9.254zm-6.673-3.24 6.355 2.928-8.58 3.344L4.318 7.4 12.35 4.09c.314-.129.668-.122.976.02",
    className: "Mottaker_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Mottaker_svg__flowIconSnowStorm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.134 5 5.903 2.901.527.645-.757.295.564-.218v2.545l-2.145.862V9.457l.008-.004-.598-.611-5.952-2.847zM5.98 11.701l2.747 1.11a.22.22 0 0 1 .138.206v3.843a.222.222 0 0 1-.304.206l-2.746-1.11a.22.22 0 0 1-.139-.205l-.001-3.844a.222.222 0 0 1 .305-.206"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.846 15.273.154.054V16l-.154-.057zm-.405-.147.154.052v.675l-.154-.057zm-.666-.241.193.071v.672l-.193-.07zm-.38-.136.225.082v.672l-.226-.081zM6 14.607l.304.108v.673L6 15.28zM6 14l.304.108v.371L6 14.37z",
    className: "Mottaker_svg__flowIconPrimary"
  }))));
};
export default SvgMottaker;